export enum EddEmbeddedFields {
  EDD_EMBEDDED_WHAT_DO_YOU_SELL = 'edd-embedded-what-do-you-sell',
  EDD_EMBEDDED_TO_WHO_YOU_SELL = 'edd-embedded-to-who-you-sell',
  EDD_EMBEDDED_WHY_DID_YOU_CHOOSE = 'edd-embedded-why-did-you-choose',
  EDD_EMBEDDED_CUSTOMER_LOCATION = 'edd-embedded-customer-location',
  EDD_EMBEDDED_VENDOR_LOCATION = 'edd-embedded-vendor-location',
  EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS = 'edd-embedded-monthly-payment-transactions',
  EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME = 'edd-embedded-monthly-payment-volume',
  EDD_EMBEDDED_INTERNATIONAL_ACTIVITY = 'edd-embedded-international-activity',
  EDD_ADDITIONAL_BUSINESS_LOCATIONS_HAS_ADDITIONAL = 'EDD_ADDITIONAL_BUSINESS_LOCATIONS_HAS_ADDITIONAL',
  EDD_ADDITIONAL_BUSINESS_LOCATIONS_LOCATIONS = 'EDD_ADDITIONAL_BUSINESS_LOCATIONS_LOCATIONS',
  EDD_BUSINESS_SIZE = 'EDD_BUSINESS_SIZE',
  EDD_ANNUAL_REVENUE = 'EDD_ANNUAL_REVENUE',
  EDD_INTENDED_USE = 'EDD_INTENDED_USE',
  EDD_INTENDED_USE_OTHER_FREE_TEXT = 'EDD_INTENDED_USE_OTHER_FREE_TEXT',
  EDD_WEBSITE_URL = 'EDD_WEBSITE_URL',
  EDD_ONLINE_PROFILE_URL = 'EDD_ONLINE_PROFILE_URL',
  EDD_NO_PUBLIC_SITE = 'EDD_NO_PUBLIC_SITE',
  EDD_WEBSITE_OPTION = 'EDD_WEBSITE_OPTION',
  EDD_BUSINESS_CAPITAL_SOURCE = 'EDD_BUSINESS_CAPITAL_SOURCE',
  EDD_BUSINESS_CAPITAL_SOURCE_OTHER_FREE_TEXT = 'EDD_BUSINESS_CAPITAL_SOURCE_OTHER_FREE_TEXT',
  EDD_FUNDING_SOURCES_SELECTED = 'EDD_FUNDING_SOURCES_SELECTED',
  EDD_FUNDING_BANK_TRANSFER = 'EDD_FUNDING_BANK_TRANSFER',
  EDD_FUNDING_CHECK_DEPOSIT = 'EDD_FUNDING_CHECK_DEPOSIT',
  EDD_FUNDING_COMMERCE_PLATFORM = 'EDD_FUNDING_COMMERCE_PLATFORM',
  EDD_FUNDING_PAYMENT_PLATFORM = 'EDD_FUNDING_PAYMENT_PLATFORM',
  EDD_FUNDING_CREDIT_LOAN = 'EDD_FUNDING_CREDIT_LOAN',
  EDD_FUNDING_OTHER = 'EDD_FUNDING_OTHER',
  EDD_ORGANIZATION_ROLE = 'EDD_ORGANIZATION_ROLE',
  EDD_ORGANIZATION_ROLE_OTHER_FREE_TEXT = 'EDD_ORGANIZATION_ROLE_OTHER_FREE_TEXT',
  EDD_NONPROFIT_DESCRIPTION_A = 'EDD_NONPROFIT_DESCRIPTION_A',
  EDD_NONPROFIT_DESCRIPTION_B = 'EDD_NONPROFIT_DESCRIPTION_B',
  EDD_NONPROFIT_DESCRIPTION_C = 'EDD_NONPROFIT_DESCRIPTION_C',
  EDD_NONPROFIT_DESCRIPTION_D = 'EDD_NONPROFIT_DESCRIPTION_D',
  EDD_NONPROFIT_DESCRIPTION_E = 'EDD_NONPROFIT_DESCRIPTION_E',
  EDD_BENEFICIARY_SELECTION = 'EDD_BENEFICIARY_SELECTION',

  EDD_NONPROFIT_FUNDING_SOURCES_SELECTED = 'EDD_NONPROFIT_FUNDING_SOURCES_SELECTED',
  EDD_NONPROFIT_FUNDING_OTHER = 'EDD_NONPROFIT_FUNDING_OTHER',
  EDD_NONPROFIT_DONORS = 'EDD_NONPROFIT_DONORS',
  EDD_NONPROFIT_ORGANIZATION_SIZE = 'EDD_NONPROFIT_ORGANIZATION_SIZE',
  EDD_NONPROFIT_MONTHLY_TRANSACTIONS = 'EDD_NONPROFIT_MONTHLY_TRANSACTIONS',
  EDD_NONPROFIT_MONTHLY_TRANSACTION_VALUE = 'EDD_NONPROFIT_MONTHLY_TRANSACTION_VALUE',
  EDD_NONPROFIT_AFFILIATION = 'EDD_NONPROFIT_AFFILIATION',
  EDD_NONPROFIT_AFFILIATION_DETAILS = 'EDD_NONPROFIT_AFFILIATION_DETAILS',
  EDD_NONPROFIT_WEBSITE = 'EDD_NONPROFIT_WEBSITE',
  EDD_NONPROFIT_SOCIAL_MEDIA = 'EDD_NONPROFIT_SOCIAL_MEDIA',

  EDD_SANCTIONED_COUNTRIES = 'EDD_SANCTIONED_COUNTRIES',
  EDD_SANCTIONED_COUNTRY_RUSSIA = 'EDD_SANCTIONED_COUNTRY_RUSSIA',
  EDD_SANCTIONED_COUNTRY_SAUDI_ARABIA = 'EDD_SANCTIONED_COUNTRY_SAUDI_ARABIA',
  EDD_SANCTIONED_COUNTRY_IRAN = 'EDD_SANCTIONED_COUNTRY_IRAN',
  EDD_SANCTIONED_COUNTRY_IRAQ = 'EDD_SANCTIONED_COUNTRY_IRAQ',
  EDD_SANCTIONED_COUNTRY_SUDAN = 'EDD_SANCTIONED_COUNTRY_SUDAN',
  EDD_SANCTIONED_COUNTRY_LEBANON = 'EDD_SANCTIONED_COUNTRY_LEBANON',
  EDD_SANCTIONED_COUNTRY_SYRIA = 'EDD_SANCTIONED_COUNTRY_SYRIA',
  EDD_SANCTIONED_COUNTRY_NONE = 'EDD_SANCTIONED_COUNTRY_NONE',
  EDD_CHARITIES = 'EDD_CHARITIES',
  EDD_CHARITIES_DETAILS = 'EDD_CHARITIES_DETAILS',
  EDD_MILITARY_EQUIPMENT = 'EDD_MILITARY_EQUIPMENT',
  EDD_PRECIOUS_METALS = 'EDD_PRECIOUS_METALS',
  EDD_CASH_PAYMENTS = 'EDD_CASH_PAYMENTS',
  EDD_CASH_PAYMENTS_PERCENTAGE = 'EDD_CASH_PAYMENTS_PERCENTAGE',

  EDD_TAX_LEGAL_SERVICES = 'EDD_TAX_LEGAL_SERVICES',
  EDD_TAX_LEGAL_SERVICES_US = 'EDD_TAX_LEGAL_SERVICES_US',
  EDD_FUND_TRANSFER = 'EDD_FUND_TRANSFER',
  EDD_FUND_TRANSFER_US = 'EDD_FUND_TRANSFER_US',
  EDD_INVESTMENT_ADVICE = 'EDD_INVESTMENT_ADVICE',
  EDD_CUSTODIAL_SERVICES = 'EDD_CUSTODIAL_SERVICES',
}
